/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class NotificationService {
    /** @ngInject */
    constructor($rootScope, $translate, configuration, $log) {
        this.$rootScope = $rootScope;
        this.$translate = $translate;
        this.configuration = configuration;
        this.$log = $log;
        $log.debug('Service \'NotificationService\' loaded');
    }

    /**
     * Pushes a notification with a message.
     * 
     * @param {String} message The message.
     * @param {Integer} level Level of information (see Configuration.NOTIFIER_LEVEL_* constants).
     */
    pushMessage(message, level) {
        this.pushMessageWithParameters(message, null, level);
    }

    /**
     * Pushes a notification with a message.
     * 
     * @param {String} message The message.
     * @param {Object} parameters Message parameters for translation, null if none.
     * @param {Integer} level Level of information (see Configuration.NOTIFIER_LEVEL_* constants).
     */
    pushMessageWithParameters(message, parameters, level) {
        this.$translate(message, parameters).then(translation => {
            this.$rootScope.$emit(this.configuration.NOTIFICATION_EVENT_NAME, translation, level);
        }).catch(error => {
            this.$log.error(`Missing translation: [${message}]`);
        });
    }
}

export { NotificationService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/service/NotificationService.js